<template>
    <div class="accessibility-component">
        <div class="custom-box">
            <!-- <step
                titleColor="green"
                otherClass="first-step"
            >
                <p slot="title">Step 1</p>
                <p slot="text">Calculate Phytate Accessibility Factor</p>
            </step> -->
            <div class="w-11/12 sl:w-4/5 mx-auto py-6 sl:py-10">
                <div class="circle-step-section flex items-center pb-0 sl:pb-6">
                    <div class="font-medium rounded-full flex flex-col justify-center items-center text-brand-100 text-lg md:text-2xl border-2 border-solid border-brand-100 bg-brand-900 w-16 h-16 lg:w-72 lg:h-72 leading-tight">
                        <span>1</span> <div class="text-sm">Step</div></div>
                    <div class="ml-5 lg:ml-8 flex-1">
                        <h2 class="text-xl lg:text-3xl 2xl:text-4xl text-blue-100 font-bold">Calculate Phytate Accessibility Factor</h2>
                        <p class="text-gray-200 text-xs md:text-lg hidden md:block">Select an existing or create a new Diet or skip by entering your own Phytate-P value.</p>
                    </div>
                </div>
                <div class="column is-12">
                    <div class="accessibility-card flex border-t border-b border-solid border-gray-300 mb-6 2xl:mb-10">
                        <div class="left-part w-1/2 flex flex-col md:flex-row items-center py-6 2xl:py-10 px-5 border-r border-solid border-gray-300 text-gray-200">
                            <p class="w-full md:w-2/3">
                                The default Phytate Accessibility Factor is
                            </p>
                            <p class="text-brand-100 w-full md:w-1/3 percentage mt-6 md:mt-0 md:ml-8 has-text-centered font-bold text-3xl md:text-4xl 2xl:text-5xl">
                                {{calculatedDefaultValue*100}} %
                            </p>
                        </div>
                        <div class="right-part w-1/2 flex flex-col md:flex-row items-center py-6 2xl:py-10 px-5 text-gray-200">
                            <p class="w-full md:w-3/5">Your Accessible phytate P estimate (raw material leverage only) is</p>
                            <p class="text-brand-100 w-full md:w-1/3 percentage mt-6 md:mt-0 md:ml-8 has-text-centered font-bold text-3xl md:text-4xl 2xl:text-5xl">
                                {{roundedAccessiblePhytate}} %
                            </p>
                        </div>
                    </div>
                    <div
                        v-if="selectedAnimal != 'Layer' && selectedAnimal != 'Aqua' && selectedAnimal != 'Trout' && selectedAnimal != 'Seabream' && selectedAnimal != 'Tilapia' && (user.type == 'Super Admin' || user.type == 'Administrator' || user.type == 'Advanced' || user.type == 'Advanced + Dig. Ca')"
                        class="text-center grow w-full lg:w-3/5 mx-auto"
                    >
                        <p class=" has-text-centered text-black">
                            Do you wish to complete an assessment to calculate the corrected Phytate P value based on the non-raw material leverage?
                        </p>
                        <button
                            v-if="!showCmp"
                            class="btn-large bg-brand-100 text-white text-lg font-semibold rounded-full mx-2 my-4 lg:my-8 inline-flex justify-center items-center w-4/5 md:w-auto"
                            @click="startAssessment"
                        >
                            <span class="icon mr-2">
                                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M26 13C26 5.83192 20.1681 -2.54921e-07 13 -5.68248e-07C5.83192 -8.81575e-07 1.65243e-06 5.83192 1.3391e-06 13C1.02577e-06 20.1681 5.83192 26 13 26C20.1681 26 26 20.1681 26 13ZM1.625 13C1.625 6.7277 6.7277 1.625 13 1.625C19.2723 1.625 24.375 6.7277 24.375 13C24.375 19.2723 19.2723 24.375 13 24.375C6.7277 24.375 1.625 19.2723 1.625 13ZM13.5744 18.4494C13.257 18.7669 12.7428 18.7669 12.4256 18.4494L8.36306 14.3869C8.20442 14.2283 8.125 14.0203 8.125 13.8125C8.125 13.6047 8.20442 13.3967 8.36306 13.2381C8.68055 12.9206 9.19466 12.9206 9.51194 13.2381L12.1875 15.9136L12.1875 8.125C12.1875 7.6763 12.5509 7.3125 13 7.3125C13.4491 7.3125 13.8125 7.6763 13.8125 8.125L13.8125 15.9136L16.4881 13.2381C16.8055 12.9206 17.3197 12.9206 17.6369 13.2381C17.9542 13.5555 17.9544 14.0697 17.6369 14.3869L13.5744 18.4494Z" fill="white"/>
                                </svg>
                            </span>
                            <span>Start assessment</span>
                        </button>
                        <button
                            v-else
                            class="btn-large bg-gray-600 text-brand-100 text-lg font-semibold rounded-full border border-brand-700 px-8 mx-2 my-4 inline-flex justify-center items-center"
                            @click="clickedDefault"
                        >
                            <span class="icon mr-2">
                                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13 26C5.83171 26 0 20.1683 0 13C0 5.83171 5.83171 0 13 0C20.1683 0 26 5.83171 26 13C26 20.1683 20.1683 26 13 26ZM13 1.85709C6.85587 1.85709 1.85709 6.85587 1.85709 13C1.85709 19.1441 6.85587 24.1429 13 24.1429C19.1441 24.1429 24.1429 19.1441 24.1429 13C24.1429 6.85587 19.1441 1.85709 13 1.85709Z" fill="#45AC34"/>
                                    <path d="M17.6429 18.5715C17.4053 18.5715 17.1676 18.4808 16.9863 18.2993L7.7007 9.01367C7.33789 8.65086 7.33789 8.06331 7.7007 7.7007C8.06331 7.33809 8.65106 7.33789 9.01367 7.7007L18.2993 16.9863C18.6621 17.3491 18.6621 17.9367 18.2993 18.2993C18.118 18.4808 17.8806 18.5715 17.6429 18.5715Z" fill="#45AC34"/>
                                    <path d="M8.35709 18.5715C8.11945 18.5715 7.882 18.4808 7.7007 18.2993C7.33789 17.9367 7.33789 17.3489 7.7007 16.9863L16.9863 7.7007C17.3491 7.33789 17.9367 7.33789 18.2993 7.7007C18.6619 8.06331 18.6621 8.65106 18.2993 9.01367L9.01367 18.2993C8.83237 18.4808 8.59473 18.5715 8.35709 18.5715Z" fill="#45AC34"/>
                                </svg>
                            </span>
                            <span>Use default</span>
                        </button>
                        <p class="text-grey-dark text-xs sm:text-sm md:text-base">
                            <span class="inline-block">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.4957 4.6987C10.2802 4.47147 9.92089 4.46146 9.6933 4.6775L6.06996 8.11377L4.34172 6.33935C4.12284 6.11477 3.76395 6.10985 3.53918 6.32877C3.31461 6.54746 3.30988 6.90673 3.52857 7.1313L5.6475 9.3068C5.75854 9.42088 5.90611 9.47838 6.05407 9.47838C6.19445 9.47838 6.33484 9.42654 6.44476 9.32269L10.4745 5.50107C10.7019 5.28538 10.7115 4.92611 10.4957 4.6987Z" fill="#45AC34"/>
                                    <path d="M7 0C3.14016 0 0 3.14016 0 7C0 10.8598 3.14016 14 7 14C10.8598 14 14 10.8598 14 7C14 3.14016 10.8598 0 7 0ZM7 12.8649C3.76619 12.8649 1.13512 10.234 1.13512 7C1.13512 3.76619 3.76616 1.13512 7 1.13512C10.234 1.13512 12.8649 3.76616 12.8649 7C12.8649 10.234 10.234 12.8649 7 12.8649Z" fill="#45AC34"/>
                                </svg>
                            </span>
                            <span v-text="`Using ${showCmp ? 'custom factor' : 'default factor'}`"></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div id="accessibility-step2">
            <transition
                name="fade"
                v-on:enter="scrollToId('accessibility-step2')"
            >
                <div
                    class="custom-box"
                    v-show="showCmp"
                >
                    <div class="pt-10">
                        <div class="w-11/12 2xl:w-4/5 mx-auto">
                            <div class="circle-step-section flex flex-col md:flex-row items-center 2xl:pb-6 mb-5 border-b border-gray-300">
                                <div class="flex items-center">
                                    <div class="font-medium rounded-full flex flex-col justify-center items-center text-brand-100 text-lg md:text-2xl border-2 border-solid border-brand-100 bg-brand-900 w-16 h-16 lg:w-72 lg:h-72 leading-tight">
                                        <span>2</span> <div class="text-sm">Step</div></div>
                                    <div class="ml-5 lg:ml-8 flex-1">
                                        <h2 class="text-xl lg:text-3xl 2xl:text-4xl text-blue-100 font-bold">Phytate Accessibility Factor Calculator</h2>
                                        <!-- <p class="text-gray-200 text-xs md:text-lg hidden md:block">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> -->
                                    </div>
                                </div>
                                <a
                                    slot="header-end"
                                    @click="showHelpModal = true"
                                    class="pl-6 lg:pl-8 inline-flex items-center justify-end flex-1"
                                >
                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.6955 10.576C14.9385 9.40744 15.623 7.82585 15.623 6.12254C15.623 2.25582 12.0839 -0.677722 8.18592 0.136527C5.78294 0.638377 3.88773 2.60989 3.46987 5.04225C3.10713 7.15407 3.83039 9.16088 5.25714 10.5309C6.1711 11.4086 6.7168 12.7017 6.7168 13.99V15.6628C6.43551 15.6908 6.21582 15.928 6.21582 16.2167C6.21582 16.5241 6.46505 16.7733 6.77246 16.7733C7.03104 18.0422 8.15594 19 9.5 19C10.8441 19 11.9686 18.0422 12.2272 16.7733H12.3389C12.6463 16.7733 12.8955 16.5241 12.8955 16.2167C12.8955 15.9093 12.6463 15.66 12.3389 15.66H12.2832V13.99C12.3075 13.8687 12.0462 12.1264 13.6955 10.576ZM6.0282 9.72786C4.80967 8.55779 4.27712 6.91864 4.56709 5.23073C4.9082 3.24482 6.45399 1.63558 8.41351 1.22632C11.6119 0.558403 14.5098 2.95506 14.5098 6.12254C14.5098 7.51539 13.9498 8.80892 12.933 9.76478C11.8693 10.7647 11.2363 12.091 11.1749 13.4334H10.0566V9.63104L12.1897 6.4313C12.3602 6.1755 12.2911 5.82989 12.0353 5.65936C11.7795 5.48887 11.4339 5.55794 11.2634 5.81378L10.9793 6.23989L9.74889 5.62463C9.59218 5.54628 9.40775 5.54628 9.25103 5.62463L8.02063 6.23985L7.73656 5.81374C7.56601 5.5579 7.22033 5.48884 6.96465 5.65932C6.70886 5.82989 6.63972 6.1755 6.81024 6.43127L8.94336 9.63107V13.4334H7.80269C7.66605 12.0383 7.02432 10.6844 6.0282 9.72786ZM9.5 8.45897L8.643 7.17341L9.5 6.74489L10.357 7.17341L9.5 8.45897ZM9.5 17.8867C8.77433 17.8867 8.1556 17.4209 7.92582 16.773H11.0741C10.8444 17.4209 10.2257 17.8867 9.5 17.8867ZM7.83008 15.66V14.5467H11.1699V15.66H7.83008Z" fill="#003478"/>
                                        <path d="M2.47278 9.53711L1.50864 10.0938C1.24242 10.2475 1.15121 10.5879 1.30491 10.8542C1.4594 11.1217 1.80032 11.2109 2.06529 11.0579L3.02942 10.5012C3.29565 10.3475 3.38686 10.0071 3.23315 9.74085C3.07945 9.47461 2.73901 9.38336 2.47278 9.53711Z" fill="#003478"/>
                                        <path d="M16.5272 2.70797L17.4913 2.15131C17.7576 1.9976 17.8488 1.65714 17.695 1.39091C17.5413 1.12464 17.2009 1.03346 16.9347 1.18717L15.9706 1.74383C15.7043 1.89755 15.6131 2.238 15.7668 2.50424C15.921 2.77132 16.2617 2.86124 16.5272 2.70797Z" fill="#003478"/>
                                        <path d="M3.02942 1.74383L2.06529 1.18717C1.79903 1.03335 1.45858 1.12468 1.30491 1.39091C1.15121 1.65714 1.24242 1.9976 1.50864 2.15131L2.47278 2.70797C2.73782 2.86106 3.07882 2.77162 3.23315 2.50424C3.38686 2.238 3.29565 1.89755 3.02942 1.74383Z" fill="#003478"/>
                                        <path d="M15.9706 10.5013L16.9347 11.0579C17.1998 11.211 17.5407 11.1216 17.695 10.8542C17.8488 10.5879 17.7576 10.2475 17.4913 10.0938L16.5272 9.53711C16.2609 9.38332 15.9206 9.47458 15.7668 9.74085C15.6131 10.0071 15.7043 10.3475 15.9706 10.5013Z" fill="#003478"/>
                                        <path d="M0 6.12254C0 6.42997 0.249227 6.6792 0.556641 6.6792H1.70703C2.01445 6.6792 2.26367 6.42997 2.26367 6.12254C2.26367 5.81512 2.01445 5.56588 1.70703 5.56588H0.556641C0.249227 5.56588 0 5.81512 0 6.12254Z" fill="#003478"/>
                                        <path d="M18.4434 5.56588H17.293C16.9856 5.56588 16.7363 5.81512 16.7363 6.12254C16.7363 6.42997 16.9856 6.6792 17.293 6.6792H18.4434C18.7508 6.6792 19 6.42997 19 6.12254C19 5.81512 18.7508 5.56588 18.4434 5.56588Z" fill="#003478"/>
                                    </svg>
                                    <span class="pl-1 text-blue-100 font-medium text-base 2xl:text-lg">How does this work?</span>
                                </a>
                            </div>
                        </div>
                        <accessibilitycmp
                            :totalPhytateP="phytate"
                            :accessiblePhytateP="accessiblePhytate"
                            :accessiblePhytatePCalculated="accessiblePhytateCalculated"
                            :defaultValue="defaultValue"
                            :calculatedDefaultValue="calculatedDefaultValue"
                            :useDefault="useDefault"
                            :animal="selectedAnimal"
                            :selectedProductVersion="selectedProductVersion"
                            @correctedPhytatePUpdated="payload => {correctedPhytateP = payload.correctedPhytateP}"
                            @accessibilityUpdated="handleAccessibilityUpdated"
                            v-show="showCmp"
                        ></accessibilitycmp>
                    </div>
                </div>
            </transition>
        </div>
        <custom-modal
            :showModal="showHelpModal"
            title="How does this work?"
            @update:showModal="newValue => showHelpModal = newValue"
            :showFooter="true"
            :cardStyleClass="'w-full'"
            :modalStyleClass="'px-4 lg:px-32'"
            :cancelBtn="{ text: 'Close', type: 'blank' }"
            :showSubmitBtn="false"
        >
            <div
                slot="body"
                class="flex flex-col items-center xl:px-32"
            >
                <label
                    class="block text-grey-darker mb-4 text-lg sm:text-xl md:text-2xl"
                    for="matrixName"
                >
                    Factors that influence the solubility/accessibility of dietary phytate.
                </label>
                <div class="bg-blue-lightest border-l-4 border-blue-light text-blue-darkest px-4 py-3 mb-4 flex items-center">
                    <div class="h-8 w-8 mr-4 flex-no-shrink">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            class="icon-information w-full h-full stroke-current fill-none font-semibold text-primary inline-block"
                        >
                            <path
                                class="primary"
                                d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
                            />
                            <path
                                class="secondary"
                                d="M11 12a1 1 0 0 1 0-2h2a1 1 0 0 1 .96 1.27L12.33 17H13a1 1 0 0 1 0 2h-2a1 1 0 0 1-.96-1.27L11.67 12H11zm2-4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                            /></svg>
                    </div>
                    <div>For more information refer to the <a
                            class="shadow-underline font-semibold"
                            href="/research-paper/pfn"
                            target="_blank"
                        >Phytate Free Nutrition paper</a>
                    </div>
                </div>
                <img
                    src="/images/accessibility.png"
                    alt="accessibility"
                >
            </div>
        </custom-modal>
    </div>
</template>
<script>
import accessibilitycmp from "../components/AccessibilityCmp";

export default {
    components: {
        accessibilitycmp
    },
    props: ["selectedAnimal", "defaultValue", "totalPhytateP", "user","selectedProductVersion"],
    data() {
        return {
            showCmp: false,
            useDefault: true,
            accessibility: this.defaultValue,
            correctedPhytateP: 0.0,
            showHelpModal: false,
            calculatedDefaultValue: 0,
        };
    },

    computed: {
        phytate() {
            return Number(this.totalPhytateP);
        },
        accessiblePhytateCalculated() {
            return Number(this.totalPhytateP) * this.defaultValue;
        },
        accessiblePhytate() {
            return Number(this.totalPhytateP) * this.calculatedDefaultValue;
        },
        roundedAccessiblePhytate() {
            return _.round(this.accessiblePhytate, 3);
        }
    },

    methods: {
        clickedDefault: function() {
            this.useDefault = true;
            this.showCmp = false;
            this.accessibility = this.calculatedDefaultValue;
            this.correctedPhytateP = this.accessiblePhytate;
        },
        startAssessment: function() {
            this.showCmp = true;
            this.useDefault = false;
        },
        scrollToId(elId) {
            this.$scrollTo(`#${elId}`, 1000, { easing: "ease-in-out" });
        },
        handleAccessibilityUpdated(payload) {
            if (this.calculatedDefaultValue === 0) {
                this.calculatedDefaultValue = _.round(payload.correctedAccessibility, 2)
            }
            this.accessibility = payload.correctedAccessibility;
        }
    },
    watch: {
        correctedPhytateP: function() {
            EventHub.$emit("correctedPhytatePUpdated", this.correctedPhytateP);
        },
        accessiblePhytate: function() {
            EventHub.$emit("accessiblePhytatePUpdated", this.accessiblePhytate);
        },
        selectedAnimal: function(newValue, oldValue) {
            if (newValue == "Layer") {
                this.showCmp = false;
            }
        },
        accessibility: function() {
            EventHub.$emit("correctedAccessibilityUpdated", this.accessibility);
        },
        calculatedDefaultValue: function() {
            EventHub.$emit("defaultCalculatedAccessibilityUpdated", this.calculatedDefaultValue);
        }
    }
};
</script>
<style type="text/css">
.card-primary {
    background-color: #22a7f0;
    border-bottom-right-radius: 5px;
}
</style>

<style scoped>
  .accessibility-component >>> .modal-card {
    width: 100% !important;
  }
</style>
